import { ISelectOption } from './i-select-option';

export class OrderListFilterOptions {
    public providers: ISelectOption[];
}
